import { Route, Routes } from 'react-router';

import AddNewFeaturedBanner from './AddNewFeaturedBanner';
import FeaturedBannerList from './FeaturedBannerList';

function FeaturedBannerModule() {
  return (
    <Routes>
      <Route index={true} element={<FeaturedBannerList />} />
      <Route path="new" element={<AddNewFeaturedBanner />} />
    </Routes>
  );
}

export default FeaturedBannerModule;
